// Fremder Text (zitierte Mail, Betreff, Absendername) landet beim Antworten im
// Vorlagentext, den /api/email_preview mit Twig rendert. Twig-Öffner werden darum
// als Twig-Literal ausgegeben: Nach dem Rendern steht wieder exakt der Originaltext da,
// aber nichts davon wird als Vorlage ausgeführt.
export default function escapeTwig(text) {
    if (!text) {
        return text;
    }

    return String(text).replace(/\{([{%#])/g, (match, opener) => `{{ '{${opener}' }}`);
}
